import { useEffect, useRef } from 'react'
import { tracker } from './index'
import { backendUrl } from '../config'
import { getConsent, onConsentChange } from './consent'

const GA4_ID = 'G-6QZS0HJX9Y'
const isProduction = process.env.REACT_APP_NODE_ENV === 'production'

function loadGA4(id) {
  if (typeof document === 'undefined') return
  if (window.__lw_ga4_loaded) return
  window.__lw_ga4_loaded = true

  const s = document.createElement('script')
  s.async = true
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
  document.head.appendChild(s)

  window.dataLayer = window.dataLayer || []
  window.gtag = function () { window.dataLayer.push(arguments) }
  window.gtag('js', new Date())
  window.gtag('config', id, { anonymize_ip: true })
}

function bootIfConsented() {
  const consent = getConsent()
  if (!consent?.analytics) return
  if (!isProduction) return
  tracker.init({ apiUrl: backendUrl + 'api/analytics' })
  loadGA4(GA4_ID)
}

/**
 * Mount-once gate. Boots custom tracker + GA4 when the user consents to
 * analytics. If consent is already stored (returning visitor), boots
 * immediately. If not, waits for a lw:consent-change event.
 */
export default function AnalyticsGate() {
  const mounted = useRef(false)

  useEffect(() => {
    if (mounted.current) return
    mounted.current = true

    bootIfConsented()

    const unsubscribe = onConsentChange((state) => {
      if (state?.analytics) {
        bootIfConsented()
      }
    })
    return unsubscribe
  }, [])

  return null
}
